import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { TopicFilterNames } from 'components/TopicFilters/shared';

import { EntityTypes } from 'context/entityContext';
import { SalesTypeValues } from 'maps/sales-types';

export interface IAudienceTrendUrlArgs {
  ageGroupsMode: 'summed' | 'grouped';
  gendersMode: 'summed' | 'grouped';
  countryIds?: string[];
  download?: boolean;
  entityType: EntityTypes;
  entityIds: string[];
  period?: string;
  salesType: SalesTypeValues;
  isUnique?: boolean;
  compareMode?: string;
  customerFilter?: TopicFilterNames[];
}

function getAudienceTrendUrl(args: IAudienceTrendUrlArgs): string {
  const {
    ageGroupsMode,
    gendersMode,
    countryIds,
    download,
    entityType,
    entityIds,
    period,
    salesType = 'streaming',
    customerFilter,
    compareMode,
  } = args;

  const type = entityTypeToApiType(entityType);

  const params = stringify({
    countryIds,
    customerFilter,
    download,
    period,
    ageGroupsMode,
    gendersMode,
    regionBreakdown: compareMode === 'country' ? undefined : 'none',
    ageGroupType: customerFilter ? 'real' : 'standardized',
  });

  const url = `/api/${salesType}/demographics/${type}/${entityIds}/trend?${params}`;

  return url;
}

export default getAudienceTrendUrl;
